"use strict";
Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _servicesAPIClient = require('../services/APIClient');

var _servicesAPIClient2 = _interopRequireDefault(_servicesAPIClient);

/**
* Queries constructor. Handles the configuration to build urls.
* Uses APIClient to perform the HTTP requests
*/

var QueryBuilder = (function () {
    /**
    * Builds the object based on given parameters.
    * @param {object=} params
    * @constructor
    */

    function QueryBuilder() {
        var params = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

        _classCallCheck(this, QueryBuilder);

        //search parameters
        this.q = params.q || '';
        this.or = params.or || null;
        this.not = params.not || null;
        this.exactMatch = params.exact || false;
        //this can be open field value pair data.
        //{ album: 'gold', year: 2014 }
        this.filters = params.filters || {};
        this.type = params.type || '';
        this.market = params.market || false;
        this.limit = params.limit || 50;
        this.offset = params.offset || 0;

        //specific entities get
        this.id = params.id || '';
        //required by aouth method
        this.user = params.user_id ? '/users/' + params.user_id : null;
        //specfic /artists/{id}/albums
        this.album_type = params.album_type || false;
        //helper to build url
        this.query_type = params.query_type || 'search';
    }

    /**
    * Returns an API Client.
    * @return {APIClient}
    */

    _createClass(QueryBuilder, [{
        key: '_getClient',
        value: function _getClient() {
            return _servicesAPIClient2['default'];
        }

        /**
        * Builds url for a generic search.
        * @return {string}
        */
    }, {
        key: '_getSearchUrl',
        value: function _getSearchUrl() {
            //@TODO improve to include all parameters into url
            var q = this.exactMatch ? '"' + this.q + '"' : this.q;
            var url = '/search?q=' + q + ('&type=' + this.factory._getType().slice(0, -1) /*be careful with this chunk of last char*/) + ('&limit=' + this.limit) + ('&offset=' + this.offset);
            this.selector = 'response.' + this.factory._getType() + '.items';
            return url;
        }

        /**
        * Builds url for an artist top tracks search.
        * @return {string}
        */
    }, {
        key: '_getArtistsTopTracksUrl',
        value: function _getArtistsTopTracksUrl() {
            var url = '/' + this.type + '/' + this.id + '/top-tracks?country=' + this.market;
            this.selector = 'response.tracks';
            return url;
        }

        /**
        * Builds url for an artist albums search.
        * @return {string}
        */
    }, {
        key: '_getArtistsAlbumsUrl',
        value: function _getArtistsAlbumsUrl() {
            var url = '/' + this.type + '/' + this.id + '/albums?';
            url += this.album_type ? 'album_type=' + this.album_type : '';
            url += this.market ? 'country=' + this.market : '';
            url += '&limit=' + this.limit + '&offset=' + this.offset;
            this.selector = 'response.items';
            return url;
        }
    }, {
        key: '_getRelatedArtistsUrl',
        value: function _getRelatedArtistsUrl() {
            var url = '/' + this.type + '/' + this.id + '/related-artists';
            this.selector = 'response.artists';
            return url;
        }
    }, {
        key: '_getWritePlaylistUrl',
        value: function _getWritePlaylistUrl() {
            return this.user + '/playlists/' + this.id + '/';
        }
    }, {
        key: '_getWritePlaylistTracksUrl',
        value: function _getWritePlaylistTracksUrl() {
            return this._getWritePlaylistUrl() + 'tracks/';
        }

        /**
        * Builds url for an entity.
        * @return {string}
        */
    }, {
        key: '_getEntityUrl',
        value: function _getEntityUrl() {
            var url = '/' + this.factory._getType() + '/' + this.id;
            if (this.user) {
                url = '' + this.user + url;
            }
            this.selector = '[ response ]';
            return url;
        }
    }]);

    return QueryBuilder;
})();

exports['default'] = QueryBuilder;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/spotify-client/lib/classes/QueryBuilder.js
 ** module id = 283
 ** module chunks = 0
 **/